export const getBase64 = (file: File | Blob) => {
  return new Promise<string | null | ArrayBuffer>((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
};
